import React, { createContext, useContext, ReactNode } from 'react'
import { CurrencyInfo } from 'types/interfaces'

interface DiamondStore {
  getDiamond: (
    searchParams: { [key: string]: any },
    searchType: string,
    role?: string
  ) => Promise<any>
  getDefaultCollections: () => Promise<any>
  getRatios: () => Promise<any>
  getExchangeRates: () => Promise<any>
  getDiamondWeights: (params: { [key: string]: any }) => Promise<any>
  getDiamondsByMerchantTemplates: (params: { [key: string]: any }, role: string) => Promise<any>
  getStatus: (sku: string) => Promise<any>
  runFilter: (
    request: { [key: string]: any },
    searchType: string,
    signal?: AbortSignal
  ) => Promise<any>
  startOTP: (email: string) => Promise<any>
  validateOTP: (methodId: string, code: string) => Promise<any>
  getShopName: () => Promise<any>
}

interface AppContextType {
  diamondStore: DiamondStore
  appConfig: any
  enabledDiamondGemTypes: string[]
  enabledSourceTypes: string[]
  typeLabels: Record<string, string>
  currencyInfo: CurrencyInfo
  isAdmin: boolean
  loaded: boolean
}

const AppContext = createContext<AppContextType | undefined>(undefined)

interface AppProviderProps {
  children: ReactNode
  value: AppContextType
}

export const AppProvider: React.FC<AppProviderProps> = ({ children, value }) => {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext)
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider')
  }
  return context
} 